import React, { useEffect, useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import GroupAnalyticReport from "./GroupAnalyticReport";
import UserAnalyticReport from "./UserAnalyticReport";
import GroupReport from "../../userAnalytic/groupreport/GroupReport";
import UserAnalytic from "../../userAnalytic/UserAnalytic";

const AnalyticReport = () => {
  const location = useLocation();
  const navigate = useNavigate();
  if(!location?.state?.group){
    navigate(`/courses`)
  }
  const userData = useSelector((state) => state.userSlice);
  const { group, module } = location.state;
  const [activeTab, setActiveTab] = useState("reports");
  const [userReportShow, setUserReportShow] = useState(null);
  const params = useParams();
  const { groupId, uuid } = params;

  useEffect(() => {
    setActiveTab("reports");
  }, []);

  const returnToUser = () => {
    setActiveTab("users");
    setUserReportShow(null);
  };

  const returnToGroup = () => {
    navigate(-1);
  };

  const handleTabSelect = (selectedTab) => {
    setActiveTab(selectedTab);
    setUserReportShow(null);
  };
  useEffect(()=> {
    setActiveTab('reports')
  }, [groupId]);

  return (
    <>
      <Tab.Container
        id="controlled-tab-example"
        activeKey={activeTab}
        onSelect={handleTabSelect}
      >
        <Nav className="tabsproduct toptab" variant="pills">
          <Nav.Item>
            <Nav.Link eventKey="reports">Report</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="groups">Groups</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="users">Users</Nav.Link>
          </Nav.Item>
        </Nav>
        <div className="container-fluid bg-grey-main pt-5">
          <Tab.Content className="groupuserscont pt-2">
            <Tab.Pane eventKey="reports">
              {userReportShow ? (
                <UserAnalytic
                  userReportShow={userReportShow}
                  returnToUser={returnToUser}
                />
              ) : (
                <GroupReport
                  module={module}
                  group={group}
                  returnToGroup={returnToGroup}
                />
              )}
            </Tab.Pane>

            <Tab.Pane eventKey="groups">
              <GroupAnalyticReport onSelect={(group) => navigate(`/module/report/group/${group.uuid}/${module.uuid}` , {state : {group , module }})} />
            </Tab.Pane>

            <Tab.Pane eventKey="users">
              <UserAnalyticReport moduleUUID={module.uuid} />
            </Tab.Pane>
          </Tab.Content>
        </div>
      </Tab.Container>
    </>
  );
};

export default AnalyticReport;